
import { IntroSlider } from "../../../../../components/IntroSlider/IntroSlider";
import styles from "./NewsSection.module.scss";

export const NewsSection = () => {
	return (
		<section className={styles.newssection}>
			<h2 className={styles.newssection__header}>Новости карьеры</h2>
			<IntroSlider />
		</section>
	);
};
